import { render, staticRenderFns } from "./SetPasswordView.vue?vue&type=template&id=4d7b168c"
import script from "./SetPasswordView.vue?vue&type=script&lang=js"
export * from "./SetPasswordView.vue?vue&type=script&lang=js"
import style0 from "./SetPasswordView.vue?vue&type=style&index=0&id=4d7b168c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports